import { CONSTANTS } from "../actions";

export const setActiveLocation = (name, id, subOid, isAdmin) => {
  return {
    type: CONSTANTS.SET_ACTIVE_LOCATION,
    payload: { name, id, subOid, isAdmin }
  };
};
